import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import rootReducer, { initialState } from '../reducers'
import dynamoDb from './aws'

const logger = createLogger({
  collapsed: true,
})

// initialState arg is useful to match server store with client
export default (state = initialState) => {
  const middlewares = [thunk.withExtraArgument({ dynamoDb })]

  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(logger)
  }

  return createStore(
    rootReducer,
    state,
    composeWithDevTools(applyMiddleware(...middlewares)),
  )
}



// WEBPACK FOOTER //
// ./src/config/store.js